import { createRoot } from 'react-dom/client';

import App from './App';
import './reset.css';
import './style.css';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  // Mount main JŽK app
  const container = document.getElementById('cdcargo-jzk-data-container');

  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  }
});
